import SimpleCollectionList from "../../Collections/SimpleCollectionList";

export {EventProgressItem as default};

/**
* Event Progress
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class EventProgressItem {
  /**
   * Event id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  id;

  /**
   * Event name
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  name;

  /**
   * Stores all event items in queue
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {SimpleCollectionList}
   */
  queue = new SimpleCollectionList();

  /**
   * Stores all event items that finished processing
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {SimpleCollectionList}
   */
  finished = new SimpleCollectionList();

  /**
   * Event progress percentage
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  progress = 0;

  /**
   * Updates event progress percentage
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  updateProgress() {
    this.progress = (this.finished.count * 100) / this.queue.total;
  }
}